import { HttpClient } from '@angular/common/http';
import { Component } from '@angular/core';
import { initFlowbite } from 'flowbite';
import { KeycloakService } from 'keycloak-angular';
import { config } from './config/api.config';
import { BackendApiService } from './service/backend-api.service';
import { map } from 'rxjs';
import { SpinnerServiceService } from './modules/shared/serviceSpinner/spinner-service.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'forceNApp';

  showSpinner = false;

  constructor(private keycloak:KeycloakService,private spinnerService:SpinnerServiceService){
    this.spinnerService.spinner$.subscribe((data: boolean) => {
      setTimeout(() => {
        this.showSpinner = data ? data : false;
      });
    });
  }

  async ngOnInit(): Promise<void> {
    initFlowbite();

    this.spinnerService.showSpinner()

   

   
  }

}
